
import {
  cityName,
  directionsUrl,
  formatKm,
  websiteUrl,
} from '@/utils/partnerLocator'

export default {
  name: 'PartnerLocatorNearest',
  props: {
    partner: {
      type: Object,
      required: true,
    },
  },
  computed: {
    logo() {
      return this.partner.image?.url || require('~/assets/images/partner.png')
    },
    city() {
      return cityName(this.partner.city)
    },
    distance() {
      return formatKm(this.partner.distance, this.$i18n.locale)
    },
    directions() {
      return directionsUrl(this.partner)
    },
    website() {
      return websiteUrl(this.partner.website)
    },
  },
}
